import { FormControl, FormControlLabel, FormHelperText, FormLabel, Radio, RadioGroup } from "@mui/material"
import { Controller } from "react-hook-form"
import { toTitleCase } from "../../utils/utilityFunctions"

/**
 * 
 * @param {object} props e.g. {
 *   fieldName {string} 
 *   fieldLabel {string} 
 *   control {object} as returned by useForm
 *   errors  {object} as returned by useForm
 *   options {object[]} E.g [{key: 1, value: 'one', label: 'Number One'}, ...] 
 *   rules {object|function} defaults to {required: true}
 *   optionKeysAsValues {bool} Use option.key or option.value as value returned by the Select.
 *   onChange {function} 
 * @returns JSX
 */
export function RadioGroupRequiredControl({fieldName,
        fieldLabel = '', control, errors, options, rules={required: true}, optionKeysAsValues,
        radioGroupHelperText,
        onChange, controlSx={}}) {

            return (
                <RadioGroupControl control={control} errors={errors} options={options} fieldName={fieldName}
                    fieldLabel={fieldLabel}  rules={rules} optionKeysAsValues={optionKeysAsValues}
                    radioGroupHelperText={radioGroupHelperText}
                    onChange={onChange} controlSx={controlSx}
                />
            )

}

/**
 * 
 * @param {object} props e.g. {
 *   fieldName {string} 
 *   fieldLabel {string} 
 *   control {object} as returned by useForm
 *   errors  {object} as returned by useForm
 *   options {object[]} E.g [{key: 1, value: 'one', label: 'Number One'}, ...] 
 *   rules {object|function} rules as required by react hooks form Controller
 *   optionKeysAsValues {bool} Use option.key or option.value as value returned by the Select.
 *   radioGroupHelperText text to display under the radio group
 *   onChange {function} 
 * @returns JSX
 */
export function RadioGroupControl({fieldName,
        fieldLabel = '', control, errors, options,
        rules, optionKeysAsValues,
        radioGroupHelperText,
        onChange, controlSx={}}) {
    const theLabel = (fieldLabel || toTitleCase(fieldName))
    const theLabelWithoutStar = theLabel.replace(/ \*$/, '')
    return (
        <FormControl sx={controlSx} error={!!errors[fieldName]} variant="standard">

            <FormLabel color="secondary">{theLabel}</FormLabel>
            <Controller
                rules={rules}
                name={fieldName} control={control}
                defaultValue={null}
                render={({fieldState, field}) => ( // { onChange, onBlur, value, name, ref }
                    <>
                        <RadioGroup
                            {...field}
                            onChange={(newValue) => {
                                field.onChange(newValue)
                                if (typeof onChange === 'function') {
                                    onChange(newValue)
                                }
                            }}
                        >
                            {
                                options.map((option) => (
                                    <FormControlLabel key={option.key} value={(optionKeysAsValues ? option.key : option.value)}
                                        label={option.label || option.value} control={<Radio />}
                                    />
                                ))
                            }
                        </RadioGroup>
                        {
                            (!!errors[fieldName])
                            &&
                            <FormHelperText>{fieldState?.error?.message || radioGroupHelperText || (fieldState?.error && `${theLabelWithoutStar} is required`)}</FormHelperText>
                        }
                    </>
                )}
            />
        </FormControl>
    )
}
